import lumiEnvironment from '../../lumi.environment';

/**
 * Exports feature flags used for guarding sections of code.
 * This allows us to correlate flags to jira tickets to make them more easily
 *   identifiable.
 */

export const featureFlags = {
  // LF4026NewDisbursementsPage: !lumiEnvironment.IS_PRODUCTION,
  LF4216ManualStatementsWarning: false,
  PAR2OpenPayDisbursements: true,
  LEN2BankStatementsOcr: true,
  PAR110DocCapsByAccountId: !lumiEnvironment.IS_PRODUCTION,
  LEN1355PropertyInsights1: !lumiEnvironment.IS_PRODUCTION,
  LEN98PayoutLetter: true,
  BET207NewFinanceProcess: true,
  LEN404DebitGraphs: true,
  LEN399AnnualisedRevenueBasedOnSelectedPeriods: false,
  BET359Auth0PermissionsAndRoles: true,
  CJ546AdditionalStakeholders: true,
};
